import { dispatcher, IEvent, ingenuity } from "@quest/base-core";
import {
  FreeGameMetersControllerBehavior,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
} from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";

/**
 * MetersControllerGame class handles the meters for the base game
 *  ex. win meter, win tickup etc.
 */
export class FreeGameMetersControllerGame extends FreeGameMetersControllerBehavior {

   protected subscribeEvents(): void {
    super.subscribeEvents();
    // dispatcher.on(eventDispatchers.UPDATE_TICKUP_WIN_METER_FG, this.setTickupWinValue, this);
    dispatcher.on(eventDispatchers.STOP_WIN_TICK_UP_FG, this.stopRunningTickup, this);
  }

  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    // dispatcher.off(eventDispatchers.UPDATE_TICKUP_WIN_METER_FG, this.setTickupWinValue, this);
    dispatcher.off(eventDispatchers.STOP_WIN_TICK_UP_FG, this.stopRunningTickup, this);

  }
  private stopRunningTickup():void{
    if (this.winValueMeterFg.getIsTickUpRunning()) {
      this.winValueMeterFg.stopTick();
    }
  }
  // private setTickupWinValue(evt:IEvent): void {
  //     const duration = 0.8;
  //     const value = evt.data.value;
  //     let isValueInCredit = true;
  //     if (value === 0) {
  //       dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_FREE_GAME_WIN_METER);
  //     }
  //     if (isValueInCredit) {
  //       this.winValueMeterFg?.startTick(value, true, false, duration, true, () => {});
  //     } else {
  //       const converAmountToCoinFromCurrency = Math.round(Number(value) / ingenuity.configData.currentCoinValue).toString();
  //       this.winValueMeterFg?.setCoinFormattedValueToDecimal(converAmountToCoinFromCurrency, 0);
  //     }
  // }

 /**
   * This method is use to skip cascade animation on stage click
   */
  protected onForceStopWinTickUp(evt?: IEvent): void {
    if (ingenuity.configData.stageClickOnCascade) {
      if (this.winValueMeterFg.getIsTickUpRunning()) {
        this.winValueMeterFg.forceStop((ingenuity.parserModel as GameParserModel).getCascadeAccumulatedWin(), false, true);
      }
      dispatcher.fireEvent(eventDispatchers.START_NEXT_CASCADE);
    } else {
      super.onForceStopWinTickUp();
    }
  }


 // Overrided to blank function in case of cascade
  protected tickUpComplete(): void {
    if ((ingenuity.parserModel as GameParserModel).getCascadingStatus()) {
       //
    } else {
      super.tickUpComplete();
    }
  }

  // Overrided to add cascade win amount for tickup
  protected onStartWinTickUp(evt: any): void {
    let _a, _b;
    let accumulatedWin: number = (ingenuity.parserModel as GameParserModel).getCascadeAccumulatedWin();
    this.showWinTickUpMeter();
    if ((ingenuity.parserModel as GameParserModel).getCascadingCount() !== 0) {
      (_b = this.winValueMeterFg) === null || _b === void 0
        ? void 0
        : _b.startTick(
          accumulatedWin,
          this.model.getIsCredits(),
          false,
          this.model.getWinMeterTickUpDurationFg(),
          true,
          this.tickUpComplete.bind(this)
        );
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: this.model.getWinMeterTickUpSoundFg() });
    } else {
      if (this.model.getIsFgBigWin()) {
        (_a = this.winValueMeterFg) === null || _a === void 0
          ? void 0
          : _a.startTick(
              this.model.getThresholdBigWinAmount(),
              this.model.getIsCredits(),
              false,
              SlotConstantsBehavior.WINTICKUP_FG_3_NORMAL_TICK,
              true,
              this.tickUpComplete.bind(this)
            );
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
          id: this.model.getWinMeterTickUpSoundFg(),
          vol: 1,
          loop: false,
        });
      }
    }
    this.fadeFreeGameBGM();
  }
}
